
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { TLoadable, isLoaded, createLoaded, createUnloaded } from "../../../../sg-core";
import { selectHavainnotState } from "../selectors";
import { IRole } from "../../interfaces/IHavainnotUser";
import { useUsersAppRoleIdList } from "../../auth/store/authSelectors";
import ICategory from "../../interfaces/ICategory";
import { selectCategoryPermissions, useCategoryPermission } from "./permissionSelectors";
import { useMemo } from "react";

// SELECTORS
const selectAppRoleState = createSelector(
    selectHavainnotState,
    (workPermit) => workPermit.appRole
);


export const selectAppRolesById = createSelector(
    selectAppRoleState,
    (state) => state.appRoles,
);

export const selectAppRoleList = createSelector(
    selectAppRoleState,
    (state) => state.appRoleList,
);


const selectAppRoles = createSelector(
    selectAppRoleList,
    selectAppRolesById,
    (listLoader, byId) => {
        if (isLoaded(listLoader)) {
            return createLoaded(listLoader.data.map((id) => byId[id]));
        }
        return createUnloaded();
    }
);

// HOOKS
export const useAppRoles = (): TLoadable<IRole[]> => useSelector(selectAppRoles);


export const useUserCanViewNamesOld = () => {
    const roles = useUsersAppRoleIdList();
    const appRoles = useAppRoles()
    const byId = useSelector(selectAppRolesById)

    if (isLoaded(roles) && isLoaded(appRoles)) {
        return roles.data.reduce((acc, userRole) => {
            const canView = userRole && byId[userRole] && byId[userRole].showNameDetail
            if (canView) { acc = true };
            return acc
        }, false);
    }

    return false;
}


export const useUserCanViewNames = (categoryId?: ICategory["id"]) => {

    const permissions = useSelector(selectCategoryPermissions);
    const activeRoles = useUsersAppRoleIdList();
    const appRoles = useAppRoles()
    // const byId = useSelector(selectAppRolesById);

    const canViewNames = useMemo(() => {
        if (!isLoaded(appRoles) || !isLoaded(permissions) || !isLoaded(activeRoles)) {
            return false;
        }
        const permissionsForCategory = categoryId ? permissions.data.filter((perm) => perm.categoryId === categoryId) : [];
        const rolesOfPermissions = appRoles.data.filter((role) => permissionsForCategory.find((perm) => perm.roleId === role.id));

        return rolesOfPermissions.reduce((acc, role) => {
            const canView = role && activeRoles.data.includes(role.id) && role.showNameDetail
            if (canView) {
                acc = true
            };
            return acc
        }, false);


    }, [permissions, categoryId, appRoles, activeRoles])

    
    return canViewNames;
}